<script>
import roundHelper from './mixins/roundHelper';
import MatchCard from '@/components/tournaments/PlayoffMatchCardBR';
import Grid from '../components/GridView';

const matchProps = (/*{ roundIndex, roundsCount }*/) => {
  return {
    props: {},
  };
};

export default {
  name: 'TournamentDoubleElimination',
  functional: true,
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    return h(Grid, {
      ...context.data,
      class: 'tournament-grid-battle-royale',
      props: {
        roundName: roundHelper.methods.roundName,
        matchProps,
        matchCardComponent: MatchCard,
        isAdmin: context.props.isAdmin,
        isBattleRoyale: true,
        autoHeight: false,
      },
      on: context.listeners,
    });
  },
};
</script>
<style lang="scss">
.tournament-grid-wrapper.tournament-grid-battle-royale {
  .round-step {
    min-width: 500px !important;
  }
}
</style>
